export default "__VITE_ASSET__CtwdVirk__"